import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PriorityPatchRequest, SecurityMeasureDependency } from '@primatoo-ms-organization';
import { ApiClientConfig } from '../api-client-config';
import { DataProtectionGovernanceService } from '../interface';
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';
import { SecurityMeasure } from 'it/primatoo/openapi/api/org/schemas/securitymeasure/SecurityMeasure';
import {
  GetSecurityMeasureForDetailsResponse
} from 'it/primatoo/openapi/api/org/schemas/securitymeasure/GetSecurityMeasureForDetailsResponse';
import {
  CreateSecurityMeasureRequest
} from 'it/primatoo/openapi/api/org/schemas/securitymeasure/CreateSecurityMeasureRequest';
import { CreateResponse } from 'it/primatoo/openapi/api/common/schemas/CreateResponse';
import {
  UpdateSecurityMeasureRequest
} from 'it/primatoo/openapi/api/org/schemas/securitymeasure/UpdateSecurityMeasureRequest';

@Injectable({
  providedIn: 'root'
})
export class SecurityMeasureService extends DataProtectionGovernanceService {
  private readonly endpointV1: string;
  private readonly endpointV2: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpointV1 = this.config.endPoint + '/api/org/security-measures/';
    this.endpointV2 = this.config.endPoint + '/api/org/v2/security-measures/';
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<SecurityMeasure> {
    const url = `${this.endpointV1}${id}/priority`;
    return this.httpClient.patch<SecurityMeasure>(url, request);
  }

  public getSecurityMeasures(): Observable<SecurityMeasure[]> {
    const url = this.endpointV1;
    return this.httpClient.get<SecurityMeasure[]>(url);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpointV1 + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public getSecurityMeasureDetails(id: number): Observable<GetSecurityMeasureForDetailsResponse> {
    const url = this.endpointV2 + id + '/details/';
    return this.httpClient.get<GetSecurityMeasureForDetailsResponse>(url);
  }

  public getSecurityMeasureDependencies(id: number): Observable<SecurityMeasureDependency> {
    const url = this.endpointV1 + id + '/dependency';
    return this.httpClient.get<SecurityMeasureDependency>(url);
  }

  public createSecurityMeasure(requestBody: CreateSecurityMeasureRequest): Observable<CreateResponse> {
    const url = this.endpointV2;
    return this.httpClient.post<CreateResponse>(url, requestBody);
  }

  public updateSecurityMeasure(id: number, requestBody: UpdateSecurityMeasureRequest): Observable<void> {
    const url = this.endpointV2 + id + '/';
    return this.httpClient.put<void>(url, requestBody);
  }

  public getEndPointV1(): string {
    return this.endpointV1;
  }
}
